import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';

import { ConfigurationEffects } from '@appStore/configuration/effects/configuration.effects';

export const effects: any[] = [
  ConfigurationEffects
];

@NgModule({
  imports: [EffectsModule.forFeature(effects)]
})
export class ConfigurationEffectsModule {}
